import AuthContext from 'context/AuthContext';
import React, { useContext, useState } from 'react';
import BadgeFunnelCards from './BadgeFunnelCards';
import BadgeHostLeaderboard from './BadgeHostLeaderboard';
import BadgeTimeSeriesChart from './BadgeTimeSeriesChart';

const RANGES = [
  { label: '7d', value: '7d' },
  { label: '30d', value: '30d' },
  { label: '90d', value: '90d' },
];

const BadgeAnalytics = () => {
  const { userProfile } = useContext(AuthContext);
  const storeId = userProfile?.store?.id;
  const [range, setRange] = useState('7d');

  return (
    <div className="p-3">
      <div className="d-flex align-items-center justify-content-between mb-2">
        <h4>Live Badge Analytics</h4>
        <div className="btn-group" role="group" aria-label="Date range">
          {RANGES.map((r) => (
            <button
              key={r.value}
              type="button"
              className={`btn btn-sm ${range === r.value ? 'btn-primary' : 'btn-outline-primary'}`}
              onClick={() => setRange(r.value)}
            >
              {r.label}
            </button>
          ))}
        </div>
      </div>

      <BadgeFunnelCards storeId={storeId} range={range} />
      <BadgeTimeSeriesChart storeId={storeId} range={range} />
      <BadgeHostLeaderboard storeId={storeId} range={range} />
    </div>
  );
};

export default BadgeAnalytics;
